import { useContext } from 'react';
import { oportunidadContext } from '../context/oportunidadContext';

export const useOportunidad = () => {
  return useContext(oportunidadContext);
};
